<template>
  <modal :show.sync="dialogChangeStatusStore.show" type="notice" class="modal-custom">
    <div>
      <h5 class="card-title" style="margin: 0px">
        {{dialogChangeStatusStore.status == 'approved' ? 'Approve' : 'Reject'}} Content?
      </h5>
      <hr/>
      <div class="typography-line-custom">
        <textarea placeholder="Message" v-validate="'required'" type="text" required
          v-model="message" style="width: 100%" class="custom-textarea"/>
      </div>
      
      <!-- Actions -->
      <div class="row">
        <p-button link type="info" round outline size="sm" @click="changeStatusCampaignContent">
          Confirm
        </p-button>                
        <p-button link type="danger" round outline size="sm" @click="closeDialog">
          Cancel
        </p-button> 
      </div>
    </div>
  </modal>
</template>

<script>
import store from '@/store/index.js'
import { Modal } from 'src/components/UIComponents'
import { mapGetters } from 'vuex'

export default {
  name: 'DialogChangeStatus',
  components: { Modal },
  data() {
    return {
      message: ''
    }
  },
  computed: { 
    ...mapGetters(['dialogChangeStatusStore']),
    ...mapGetters(['campaignContentDetailStore']) 
  },
  methods: {
    closeDialog() {
      store.commit('closeDialogChangeStatus')
      this.message = ''
    },
    changeStatusCampaignContent() {
      store.dispatch('changeStatusCampaignContent', {
        contentId: this.campaignContentDetailStore._id,
        influencerId: this.campaignContentDetailStore.influencerId
      })
      if (this.message != '') {
        store.dispatch('createContentNote', {
          contentId: this.campaignContentDetailStore._id,
          message: this.message
        })
      }
    }
  }
}
</script>